export class SendEmailReqModel {
  assignee: string;
  assigneeName: string;
  workOrderNo: string;
  workOrderType: string;
  woCategory: string;
  itemNo: string;
  buyer: string;
  viewUrl: string;
  currentUser: string;
  remarks: string;
  constructor(
    assignee: string,
    assigneeName: string,
    workOrderNo: string,
    workOrderType: string,
    woCategory: string,
    itemNo: string,
    buyer: string,
    viewUrl: string,
    currentUser: string,
    remarks: string
  ) {
    this.assignee = assignee;
    this.assigneeName = assigneeName;
    this.workOrderNo = workOrderNo;
    this.workOrderType = workOrderType;
    this.woCategory = woCategory;
    this.itemNo = itemNo;
    this.buyer = buyer;
    this.viewUrl = viewUrl;
    this.currentUser = currentUser;
    this.remarks = remarks;
  }
}
